<template>
  <div class="wrapper">
    <!-- GRID VIEW -->
    <v-card class="mx-auto" color="teal darken-4" max-width="250">
      <v-list-item>
        <v-list-item-avatar color="grey">
          <v-icon medium>image</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="subtitle-1">
            Image Asset
          </v-list-item-title>
          <v-list-item-subtitle> Lang 1 </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-img
        :src="preview.imageData"
        max-height="250"
        contain
        class="grey darken-4 black--text align-end"
        @error="onImageError"
      >
        <v-card-title class="subtitle-2 font-weight-medium strokeme">
          {{ preview.name }}
        </v-card-title>
      </v-img>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click="$emit('delete')" color="error" title="Delete">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Enums from '../../helpers/Enums'

export default {
  components: {},
  props: {
    preview: {
      type: Object,
      required: true
    }
  },
  methods: {
    onImageError() {
      console.log('firing onImageError')
      //this.$refs.img.src = `https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg`;
    }
  }
}
</script>

<style scoped>
.wrapper {
  border-radius: 6px;
  overflow: hidden;
}
.text-xs-right {
  white-space: nowrap;
}
.strokeme {
  color: white;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}
</style>
